// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-note {
  width: 250px;
  border: none;
}

.cbo-search-sm {
  width: 110px;
  background-color: transparent !important;
  margin-left: -10px;
  padding-bottom: -5px;
  font-size: 1em;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/dqoi/search/detail-search/detail-search.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;AACJ;;AACA;EACI,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;AAEJ","sourcesContent":[".search-note {\n    width: 250px;\n    border: none;\n}\n.cbo-search-sm {\n    width:110px;\n    background-color: transparent !important;\n    margin-left: -10px;\n    padding-bottom:-5px;\n    font-size:1em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
